export default __webpack_public_path__ + "static/media/mzom.59cbb008.png";